import { cn } from '@/lib/utils';
import {
  PhotoSubmissionStatus,
  photoSubmissionStatusLabel,
} from './submissionStatus';

const STATUS_CLASS: Record<PhotoSubmissionStatus, string> = {
  pending:
    'border-[hsl(38_92%_64%/0.35)] bg-[hsl(38_92%_64%/0.1)] text-[hsl(38_92%_64%)]',
  approved: 'border-[#4ade80]/35 bg-[#4ade80]/10 text-[#4ade80]',
  rejected: 'border-[#f87171]/35 bg-[#f87171]/10 text-[#f87171]',
};

export function StatusChip({
  status,
  className,
}: {
  status: PhotoSubmissionStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold',
        STATUS_CLASS[status],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {photoSubmissionStatusLabel(status)}
    </span>
  );
}
